import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import SprintCreateOrEditRequest from '../../../projects/sprints/i-services/models/sprint/SprintCreateOrEditRequest';
import SprintEditStatusRequest from '../../../projects/sprints/i-services/models/sprint/SprintEditStatusRequest';
import SprintEditTypePriorityRequest from '../../../projects/sprints/i-services/models/sprint/SprintEditTypePriorityRequest';
import RemoveRequest from '../../../projects/sprints/i-services/models/RemoveRequest';
import SearchSprintRequest from '../../../projects/sprints/i-services/models/sprint/SearchSprintRequest';
import SprintGetRequest from '../../../projects/sprints/i-services/models/sprint/SprintGetRequest';
import SprintEditNameRequest from '../../../projects/sprints/i-services/models/sprint/SprintEditNameRequest';
import SprintEditDateStartEndRequest from '../../../projects/sprints/i-services/models/sprint/SprintEditDateStartEndRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import SprintSearchResponse from '../../../projects/sprints/i-services/models/sprint/SprintSearchResponse';
import SprintResponse from '../../../projects/sprints/i-services/models/sprint/SprintResponse';

export default class ProjectSprintService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	CreateEvent = new Events<WsResponseModelT<Boolean>>();
	EditStatusEvent = new Events<WsResponseModelT<Boolean>>();
	EditTypePriorityEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveEvent = new Events<WsResponseModelT<Boolean>>();
	SearchEvent = new Events<WsResponseModelT<SprintSearchResponse>>();
	GetEvent = new Events<WsResponseModelT<SprintResponse>>();
	EditNameEvent = new Events<WsResponseModelT<Boolean>>();
	EditDateStartEndEvent = new Events<WsResponseModelT<Boolean>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectSprintService', 'Create', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'EditStatus', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditStatusEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'EditTypePriority', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditTypePriorityEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'Remove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'Search', 'Main', (res: WsResponseModelT<SprintSearchResponse>) => {
			self.SearchEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'Get', 'Main', (res: WsResponseModelT<SprintResponse>) => {
			self.GetEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'EditName', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditNameEvent.trigger(res);
		});
		webApiService.on('ProjectSprintService', 'EditDateStartEnd', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditDateStartEndEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Создать спринт
	 */
	async Create(query: SprintCreateOrEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'Create',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Менять статус может владелец или админ
	 */
	async EditStatus(query: SprintEditStatusRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'EditStatus',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Менять приоритет владелец или админ
	 */
	async EditTypePriority(query: SprintEditTypePriorityRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'EditTypePriority',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалять может только админ
	 */
	async Remove(request: RemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'Remove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * искать может любой
	 */
	async Search(query: SearchSprintRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'Search',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Проверка администратор ли пользователь
	 */
	async ChecAdmin(projectId: number) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'ChecAdmin',
			Value: typeof(projectId) === 'object' ? JSON.stringify(projectId) : projectId,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение спринта
	 */
	async Get(request: SprintGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'Get',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Редактирования имени спринта
	 */
	async EditName(query: SprintEditNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'EditName',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Редактирование даты начала и конца спринта
	 */
	async EditDateStartEnd(query: SprintEditDateStartEndRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectSprintService',
			Method: 'EditDateStartEnd',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Создать спринт
	 */
	async createAsync(query: SprintCreateOrEditRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'Create',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Менять статус может владелец или админ
	 */
	async editStatusAsync(query: SprintEditStatusRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'EditStatus',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Менять приоритет владелец или админ
	 */
	async editTypePriorityAsync(query: SprintEditTypePriorityRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'EditTypePriority',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалять может только админ
	 */
	async removeAsync(request: RemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'Remove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * искать может любой
	 */
	async searchAsync(query: SearchSprintRequest): Promise<SprintSearchResponse> {
		return new Promise<SprintSearchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'Search',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<SprintSearchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SprintSearchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение спринта
	 */
	async getAsync(request: SprintGetRequest): Promise<SprintResponse> {
		return new Promise<SprintResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'Get',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<SprintResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SprintResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Редактирования имени спринта
	 */
	async editNameAsync(query: SprintEditNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'EditName',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Редактирование даты начала и конца спринта
	 */
	async editDateStartEndAsync(query: SprintEditDateStartEndRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectSprintService',
				Method: 'EditDateStartEnd',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}